import * as z from 'zod';

export const GetLlmsTxtRequest = z.object({
  options: z
    .object({
      subdomain: z
        .string()
        .describe(
          'Subdomain of the requested `llms.txt file`. For example, `www`, `es`, `fr`. Default: `www`.'
        )
        .max(63)
        .optional(),
    })
    .optional(),
});
export const GetLlmsTxtResponse = z.object({
  llmsTxt: z
    .object({
      content: z
        .string()
        .describe('CFull text content of the `llms.txt` file.')
        .max(720000)
        .optional(),
      default: z
        .boolean()
        .describe("Whether this `llms.txt` file uses Wix's default content.")
        .optional(),
      subdomain: z
        .string()
        .describe(
          "Target subdomain for the `llms.txt` file (for example, 'www', 'es', 'fr'). Default: 'www'"
        )
        .max(63)
        .optional(),
      hidden: z
        .boolean()
        .describe(
          'Whether the llms.txt file should be hidden from public access.'
        )
        .optional()
        .nullable(),
      manuallyEdited: z
        .boolean()
        .describe(
          "Whether the content was manually edited by the user. If `true` in DB, update/append requests must also set `manually_edited=true` or they'll be rejected with `FAILED_PRECONDITION`."
        )
        .optional(),
      detectedLanguage: z
        .string()
        .describe(
          'ISO 639-1 language code detected for the site (e.g. en, fr). Used to localize the MCP documentation section when serving llms.txt.'
        )
        .max(2)
        .optional(),
    })
    .describe('Retrieved `llms.txt` file entity.')
    .optional(),
});
export const UpdateLlmsTxtRequest = z.object({
  options: z
    .object({
      llmsTxt: z
        .object({
          content: z
            .string()
            .describe('CFull text content of the `llms.txt` file.')
            .max(720000)
            .optional(),
          default: z
            .boolean()
            .describe(
              "Whether this `llms.txt` file uses Wix's default content."
            )
            .optional(),
          subdomain: z
            .string()
            .describe(
              "Target subdomain for the `llms.txt` file (for example, 'www', 'es', 'fr'). Default: 'www'"
            )
            .max(63)
            .optional(),
          hidden: z
            .boolean()
            .describe(
              'Whether the llms.txt file should be hidden from public access.'
            )
            .optional()
            .nullable(),
          manuallyEdited: z
            .boolean()
            .describe(
              "Whether the content was manually edited by the user. If `true` in DB, update/append requests must also set `manually_edited=true` or they'll be rejected with `FAILED_PRECONDITION`."
            )
            .optional(),
          detectedLanguage: z
            .string()
            .describe(
              'ISO 639-1 language code detected for the site (e.g. en, fr). Used to localize the MCP documentation section when serving llms.txt.'
            )
            .max(2)
            .optional(),
        })
        .describe('`llms.txt` file to update.')
        .optional(),
    })
    .optional(),
});
export const UpdateLlmsTxtResponse = z.object({
  llmsTxt: z
    .object({
      content: z
        .string()
        .describe('CFull text content of the `llms.txt` file.')
        .max(720000)
        .optional(),
      default: z
        .boolean()
        .describe("Whether this `llms.txt` file uses Wix's default content.")
        .optional(),
      subdomain: z
        .string()
        .describe(
          "Target subdomain for the `llms.txt` file (for example, 'www', 'es', 'fr'). Default: 'www'"
        )
        .max(63)
        .optional(),
      hidden: z
        .boolean()
        .describe(
          'Whether the llms.txt file should be hidden from public access.'
        )
        .optional()
        .nullable(),
      manuallyEdited: z
        .boolean()
        .describe(
          "Whether the content was manually edited by the user. If `true` in DB, update/append requests must also set `manually_edited=true` or they'll be rejected with `FAILED_PRECONDITION`."
        )
        .optional(),
      detectedLanguage: z
        .string()
        .describe(
          'ISO 639-1 language code detected for the site (e.g. en, fr). Used to localize the MCP documentation section when serving llms.txt.'
        )
        .max(2)
        .optional(),
    })
    .describe('Updated Llms txt object')
    .optional(),
});
export const AppendLlmsTxtRequest = z.object({
  options: z
    .object({
      llmsTxt: z
        .object({
          content: z
            .string()
            .describe('CFull text content of the `llms.txt` file.')
            .max(720000)
            .optional(),
          default: z
            .boolean()
            .describe(
              "Whether this `llms.txt` file uses Wix's default content."
            )
            .optional(),
          subdomain: z
            .string()
            .describe(
              "Target subdomain for the `llms.txt` file (for example, 'www', 'es', 'fr'). Default: 'www'"
            )
            .max(63)
            .optional(),
          hidden: z
            .boolean()
            .describe(
              'Whether the llms.txt file should be hidden from public access.'
            )
            .optional()
            .nullable(),
          manuallyEdited: z
            .boolean()
            .describe(
              "Whether the content was manually edited by the user. If `true` in DB, update/append requests must also set `manually_edited=true` or they'll be rejected with `FAILED_PRECONDITION`."
            )
            .optional(),
          detectedLanguage: z
            .string()
            .describe(
              'ISO 639-1 language code detected for the site (e.g. en, fr). Used to localize the MCP documentation section when serving llms.txt.'
            )
            .max(2)
            .optional(),
        })
        .describe('`llms.txt` file to append.')
        .optional(),
    })
    .optional(),
});
export const AppendLlmsTxtResponse = z.object({
  llmsTxt: z
    .object({
      content: z
        .string()
        .describe('CFull text content of the `llms.txt` file.')
        .max(720000)
        .optional(),
      default: z
        .boolean()
        .describe("Whether this `llms.txt` file uses Wix's default content.")
        .optional(),
      subdomain: z
        .string()
        .describe(
          "Target subdomain for the `llms.txt` file (for example, 'www', 'es', 'fr'). Default: 'www'"
        )
        .max(63)
        .optional(),
      hidden: z
        .boolean()
        .describe(
          'Whether the llms.txt file should be hidden from public access.'
        )
        .optional()
        .nullable(),
      manuallyEdited: z
        .boolean()
        .describe(
          "Whether the content was manually edited by the user. If `true` in DB, update/append requests must also set `manually_edited=true` or they'll be rejected with `FAILED_PRECONDITION`."
        )
        .optional(),
      detectedLanguage: z
        .string()
        .describe(
          'ISO 639-1 language code detected for the site (e.g. en, fr). Used to localize the MCP documentation section when serving llms.txt.'
        )
        .max(2)
        .optional(),
    })
    .describe('Appended `llms.txt` file.')
    .optional(),
});
export const UpdateLlmsTxtHiddenStatusRequest = z.object({
  options: z
    .object({
      hidden: z
        .boolean()
        .describe(
          'Hidden state to set for the Llms.txt file.\nIf true, the llms.txt file will be hidden from public access (returns 404).\nIf false, the llms.txt file will be publicly accessible.'
        )
        .optional(),
      subdomain: z
        .string()
        .describe(
          'Subdomain of Llms.txt, for example `www`, `es`, `fr`. Default is `www`.'
        )
        .max(63)
        .optional(),
    })
    .optional(),
});
export const UpdateLlmsTxtHiddenStatusResponse = z.object({
  llmsTxt: z
    .object({
      content: z
        .string()
        .describe('CFull text content of the `llms.txt` file.')
        .max(720000)
        .optional(),
      default: z
        .boolean()
        .describe("Whether this `llms.txt` file uses Wix's default content.")
        .optional(),
      subdomain: z
        .string()
        .describe(
          "Target subdomain for the `llms.txt` file (for example, 'www', 'es', 'fr'). Default: 'www'"
        )
        .max(63)
        .optional(),
      hidden: z
        .boolean()
        .describe(
          'Whether the llms.txt file should be hidden from public access.'
        )
        .optional()
        .nullable(),
      manuallyEdited: z
        .boolean()
        .describe(
          "Whether the content was manually edited by the user. If `true` in DB, update/append requests must also set `manually_edited=true` or they'll be rejected with `FAILED_PRECONDITION`."
        )
        .optional(),
      detectedLanguage: z
        .string()
        .describe(
          'ISO 639-1 language code detected for the site (e.g. en, fr). Used to localize the MCP documentation section when serving llms.txt.'
        )
        .max(2)
        .optional(),
    })
    .describe('Updated Llms txt object with new hidden state')
    .optional(),
});
